import React from 'react';
import { Icon } from '@/components';

export default function Empty() {

  return (
    <div style={{textAlign: 'center', color: '#E0E6EB', paddingTop: 50,paddingBottom: 50}}>
      <Icon type="icon-kongzhuangtai" style={{fontSize: 86, color: '#E0E6EB'}} />
      <br/>
      暂无数据
    </div>
  );
}
